import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { enqueueSnackbar } from 'notistack';
import type { ReactNode } from 'react';

export const logError = (
  error?: Error,
  data?: Record<string, unknown>,
  message?: string
) => {
  datadogRum.addError(error, data);
  datadogLogs.logger.error(
    message || error?.message || 'Something went wrong',
    data,
    error
  );
};

export const toastError = (
  error?: Error,
  data?: Record<string, unknown>,
  toastMessage?: string | ReactNode,
  logMessage?: string
) => {
  enqueueSnackbar(toastMessage || error?.message || 'Something went wrong', {
    variant: 'error',
  });
  try {
    logError(error, data, logMessage);
  } catch (error) {
    console.error(error);
  }
};
